<section role="region" aria-label="hero metric subtext">
  <span [ngClass]="highlightedClass">
    {{ mode === metricModes.Comparison ? (highlightedNumber / 100 | percent: '.0-2') : highlightedNumber }}&thinsp;
  </span>
  <span>{{ subsequentText }}</span>
</section>
